import React, { Component } from 'react';
import './AssessmentReport.css';

class AssessmentSignature extends Component {
	state = {}

	render() {
		const { clinician } = this.props;

		return (
			<div className="AssessmentReport__completion-container">
				<div className="AssessmentReport__clinician-reg-container">
					<div className="AssessmentReport__clinician">
						<div className="AssessmentReport__clinician-name">
							{(clinician && clinician.firstName) && clinician.firstName} {(clinician && clinician.lastName) && clinician.lastName}
						</div>
						<div className='AssessmentReport__clinician-title'>{`${clinician ? clinician.title : ''}`}</div>
					</div>
					<div className="AssessmentReport__clinician-reg">Reg/Cert: {(clinician && clinician.cpc) && clinician.cpc}</div>
				</div>
				<div className="AssessmentReport__signature-container">
					<div className="AssessmentReport__signature"><strong>x.</strong></div>
				</div>
			</div>
		);
	}
}
 
export default AssessmentSignature;


// WEBPACK FOOTER //
// ./src/views/Assessment/AssessmentSignature.js